import React, { useMemo } from 'react';

import { useAppSelector } from '../../../../../hooks/react-redux';
import { RiskAssociated } from '../../../../admin/risk-tolerance/store';
import { getRiskLevelIndicator, getSmileyIcon, riskAssociatedColors } from '../../../../admin/risk-tolerance/utils';
import { getUser } from '../../../../auth/login/store';
import { DocumentRiskOverrideConversation } from '../../../../datasets/instances/DocumentRiskOverrideConversation';
import { DraggablePositionModal } from '../../../../shared/modal/DraggablePositionModal';
import { ModalHeader } from '../../../../shared/modal/ModalHeader';
import styles from '../../Analytics.module.scss';
import { ClientRiskConversation } from '../../../../datasets/instances/store';

const { primary } = styles;

export interface SelectedClientRiskConversation {
    clientRiskConversation: ClientRiskConversation[];
    fieldLabel: string;
}

interface ClientRiskConversationModalProps {
    closeModal: () => void;
    initialXOffset: number;
    modalWidth: number;
    modalHeight: number;
    selectedConversation: SelectedClientRiskConversation;
}

const DRAGGABLE_HEIGHT = 20;
const MODAL_PADDING = 10;
const MODAL_HEADER = 56;
const INITIAL_Y_OFFSET = 220;

export const ClientRiskConversationModal: React.FC<ClientRiskConversationModalProps> = ({ closeModal, initialXOffset, modalWidth, modalHeight, selectedConversation: { clientRiskConversation, fieldLabel } }) => {
    const user = useAppSelector(getUser);
    const conversationHeight = useMemo(() => modalHeight - (DRAGGABLE_HEIGHT + MODAL_HEADER + MODAL_PADDING), [modalHeight]);

    const overrideRiskLevel = useMemo(() => clientRiskConversation[clientRiskConversation.length - 1].overrideRiskLevel!, [clientRiskConversation]);
    const { fill, color, icon } = useMemo(() => {
        const indicator = getRiskLevelIndicator(overrideRiskLevel);
        const icon = getSmileyIcon(indicator);
        return { fill: riskAssociatedColors[overrideRiskLevel as RiskAssociated], color: primary, icon };
    }, [overrideRiskLevel]);

    return (
        <DraggablePositionModal
            closeModal={closeModal}
            isOpen
            initialPosition={{ x: initialXOffset, y: INITIAL_Y_OFFSET }}
            testId='document-analytics-conversation'
            height={`${modalHeight}px`}
            width={`${modalWidth}px`}
            shouldRepositionOnResize
        >
            <ModalHeader label={fieldLabel} icon={icon} iconColor={color} iconFill={fill} />
            <div className={styles.clientRiskConversationWrapper}>
                <DocumentRiskOverrideConversation clientRiskConversation={clientRiskConversation} isReadOnly testId='document-analytics-conversation' user={user!} conversationHeight={conversationHeight} />
            </div>
        </DraggablePositionModal>
    );
};
